import Vue from 'vue';
import Router from 'vue-router';

import * as routes from '../constants/routes';
import * as constants from '../constants';

Vue.use(Router);

const routerId = '/:id';

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: routes.LAYOUT_TEMPLATE_PAGE,
      name: constants.LAYOUT_TEMPLATE_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "must-read" */ '../views/LayoutTemplate.vue'),
    },
    {
      path: routes.LAYOUT_TEMPLATE1_PAGE,
      name: constants.LAYOUT_TEMPLATE1_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "must-read" */ '../views/LayoutTemplate1.vue'),
    },
    {
      path: routes.LAYOUT_TEMPLATE2_PAGE,
      name: constants.LAYOUT_TEMPLATE2_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "must-read" */ '../views/LayoutTemplate2.vue'),
    },
    {
      path: routes.LANDING_PAGE,
      name: constants.LANDING_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    },
    {
      path: routes.DASHBOARD_PAGE,
      name: constants.DASHBOARD_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
    },
    {
      path: routes.BOOKMARK_PAGE,
      name: constants.BOOKMARK_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "bookmark" */ '../views/Bookmark/Bookmark.vue'),
    },
    {
      path: routes.FAVORITE_PAGE + '/:courseId',
      //name: constants.FAVORITE_PAGE_CHUNK_NAME,
      //component: () => import(/* webpackChunkName: "favorite" */ '../views/Favorite.vue'),
      redirect: (to) => {
        return {
          path: `${routes.MAIN_MODE_COURSE_PAGE}/${to.params.courseId}/${routes.MAIN_MODE_COURSE_FAVORITE_PAGE}`,
        };
      },
    },
    {
      path: routes.QA_QUESTION_LIST_PAGE,
      name: constants.QA_QUESTION_LIST_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "qa-question-list" */ '../views/QA/QuestionList/QuestionList.vue'
        ),
    },
    {
      path: routes.QA_QUESTION_PAGE + routerId,
      name: constants.QA_QUESTION_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "qa-question" */ '../views/QA/Question/Question.vue'),
    },
    //{
    //  path: routes.QA_QUESTION_ASK_PAGE,
    //  name: constants.QA_QUESTION_ASK_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "qa-question-ask" */ '../views/QA/Ask.vue'),
    //},
    //{
    //  path: routes.QA_QUESTION_ASKED_PAGE,
    //  name: constants.QA_QUESTION_ASKED_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "qa-question-asked" */ '../views/QA/Asked.vue'),
    //},
    {
      path: routes.NOTES_PAGE,
      name: constants.NOTES_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "course-note-landing" */ '../views/Notes/NotesLanding/NotesLanding.vue'
        ),
    },
    {
      path: routes.NOTES_DETAILS_PAGE,
      name: constants.NOTES_DETAILS_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "course-note-detail" */ '../views/Notes/NoteDetail/NoteDetail.vue'
        ),
    },
    {
      path: `${routes.MAIN_MODE_COURSE_PAGE}/:courseId`,
      component: () =>
        import(/* webpackChunkName: "course" */ '../views/MainMode/MainModeCourse.vue'),
      children: [
        {
          path: '',
          component: () =>
            import(
              /* webpackChunkName: "course-cpnt" */ '../views/MainMode/MainModeCourse/MainModeCourseCpnt.vue'
            ),
          children: [
            {
              path: routes.MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE,
              name: constants.MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME,
              component: () =>
                import(
                  /* webpackChunkName: "course-challenge-mode" */ '../views/MainMode/MainModeCourse/MainModeCourseCpnt/ChallengeModeCourseCpnt.vue'
                ),
            },
            {
              path: '',
              redirect: {
                name: constants.MAIN_MODE_COURSE_CHALLENGE_MODE_PAGE_CHUNK_NAME,
              },
            },
            {
              path: routes.MAIN_MODE_COURSE_VIDEO_MODE_PAGE,
              name: constants.MAIN_MODE_COURSE_VIDEO_MODE_PAGE_CHUNK_NAME,
              component: () =>
                import(
                  /* webpackChunkName: "course-video-mode" */ '../views/MainMode/MainModeCourse/MainModeCourseCpnt/PureModeCourseCpnt.vue'
                ),
            },
            {
              path: routes.MAIN_MODE_COURSE_LIVE_MODE_PAGE,
              name: constants.MAIN_MODE_COURSE_LIVE_MODE_PAGE_CHUNK_NAME,
              component: () =>
                import(
                  /* webpackChunkName: "course-live-mode" */ '../views/MainMode/MainModeCourse/MainModeCourseCpnt/LiveModeCourseCpnt.vue'
                ),
            },
          ],
        },
        {
          path: routes.MAIN_MODE_COURSE_EXERCISE_PAGE,
          name: constants.MAIN_MODE_COURSE_EXERCISE_PAGE_CHUNK_NAME,
          component: () =>
            import(
              /* webpackChunkName: "course-exercise" */ '../views/MainMode/MainModeCourse/ExerciseCourseCpnt.vue'
            ),
        },
        {
          path: routes.MAIN_MODE_COURSE_EVENTS_PAGE,
          name: constants.MAIN_MODE_COURSE_EVENTS_PAGE_CHUNK_NAME,
          component: () =>
            import(
              /* webpackChunkName: "main-mode-events" */ '../views/MainMode/MainModeCourse/MainModeEvents/MainModeEvents.vue'
            ),
        },
        {
          path: routes.MAIN_MODE_COURSE_FLASHCARD_LANDING_PAGE,
          name: constants.MAIN_MODE_COURSE_FLASHCARD_LANDING_PAGE_CHUNK_NAME,
          component: () =>
            import(
              /* webpackChunkName: "main-mode-flashcard-landing" */ '../views/MainMode/MainModeCourse/MainModeFlashCardLanding/MainModeFlashCardLanding.vue'
            ),
        },
        {
          path: routes.MAIN_MODE_COURSE_FAVORITE_PAGE,
          name: constants.MAIN_MODE_COURSE_FAVORITE_PAGE_CHUNK_NAME,
          component: () =>
            import(
              /* webpackChunkName: "main-mode-favorite" */ '../views/MainMode/MainModeCourse/MainModeFavorite/MainModeFavorite.vue'
            ),
        },
        {
          path: routes.MAIN_MODE_COURSE_RANKING_PAGE,
          name: constants.MAIN_MODE_COURSE_RANKING_PAGE_CHUNK_NAME,
          component: () =>
            import(
              /* webpackChunkName: "main-mode-ranking" */ '../views/MainMode/MainModeCourse/MainModeRanking/MainModeRanking.vue'
            ),
        },
        {
          path: routes.MAIN_MODE_COURSE_MATERIAL_PAGE,
          name: constants.MAIN_MODE_COURSE_MATERIAL_PAGE_CHUNK_NAME,
          component: () =>
            import(
              /* webpackChunkName: "main-mode-material" */ '../views/MainMode/MainModeCourse/MainModeMaterial/MainModeMaterial.vue'
            ),
        },
        //{
        //  path: routes.MAIN_MODE_COURSE_CLASSROOM_PAGE,
        //  name: constants.MAIN_MODE_COURSE_CLASSROOM_PAGE_CHUNK_NAME,
        //  component: () =>
        //    import(
        //      /* webpackChunkName: "course-classroom" */ '../views/MainMode/MainModeCourse/ClassroomCourseCpnt.vue'
        //    ),
        //},
      ],
    },

    {
      path: `${routes.MINI_MODE_COURSE_PAGE}${routerId}`,
      name: constants.MINI_MODE_COURSE_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "mini-course" */ '../views/MiniMode/MiniModeCourse.vue'),
    },

    {
      path: `${routes.FREE_MODE_COURSE_PAGE}${routerId}`,
      name: constants.FREE_MODE_COURSE_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "free-course" */ '../views/FreeMode/FreeModeCourse.vue'),
    },
    {
      path: `${routes.TRAIL_MODE_COURSE_PAGE}${routerId}`,
      name: constants.TRAIL_MODE_COURSE_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "trail-course" */ '../views/TrailMode/TrailModeCourse.vue'),
    },
    {
      path: `${routes.PURE_MODE_BOOK_PAGE}`,
      name: constants.PURE_MODE_BOOK_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "Pure-Mode-book" */ '../views/PureMode/PureModeBook.vue'),
    },
    {
      path: `${routes.PURE_MODE_BOOK_PAGE}/reading/:readingId`,
      name: `${constants.PURE_MODE_BOOK_PAGE_CHUNK_NAME}-reading`,
      component: () =>
        import(/* webpackChunkName: "Pure-Mode-book" */ '../views/PureMode/PureModeBook.vue'),
    },
    {
      path: `${routes.PURE_MODE_COURSE_PAGE}`,
      //  name: constants.PURE_MODE_COURSE_PAGE_CHUNK_NAME,
      //  component: () =>
      //    import(/* webpackChunkName: "Pure-Mode-course" */ '../views/PureMode/PureModeCourse.vue'),
      redirect: (to) => {
        return {
          path: `${routes.MAIN_MODE_COURSE_PAGE}/${to.params.courseId}/${routes.MAIN_MODE_COURSE_VIDEO_MODE_PAGE}`,
        };
      },
    },
    {
      path: `${routes.MAIN_MODE_BOOK_PAGE}`,
      name: constants.MAIN_MODE_BOOK_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "book" */ '../views/MainMode/MainModeBook.vue'),
    },

    {
      path: `${routes.MINI_MODE_BOOK_PAGE}`,
      name: constants.MINI_MODE_BOOK_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "mini-book" */ '../views/MiniMode/MiniModeBook.vue'),
    },
    {
      path: `${routes.FREE_MODE_BOOK_PAGE}`,
      name: constants.FREE_MODE_BOOK_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "free-book" */ '../views/FreeMode/FreeModeBook.vue'),
    },
    {
      path: `${routes.READER_MODE_BOOK_PAGE}`,
      name: constants.READER_MODE_BOOK_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "reader-book" */ '../views/FreeMode/ReaderModeBook.vue'),
    },
    {
      path: `${routes.FREE_MODE_BOOK_PAGE}/reading/:readingId`,
      name: `${constants.FREE_MODE_BOOK_PAGE_CHUNK_NAME}-reading`,
      component: () =>
        import(/* webpackChunkName: "free-book" */ '../views/FreeMode/FreeModeBook.vue'),
    },
    {
      path: `${routes.TRAIL_MODE_BOOK_PAGE}`,
      name: constants.TRAIL_MODE_BOOK_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "trail-book" */ '../views/TrailMode/TrailModeBook.vue'),
    },
    {
      path: `${routes.EXERCISE_PAGE}/:courseId`,
      name: constants.EXERCISE_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "course-exercise" */ '../views/Exercise.vue'),
    },
    {
      path: routes.EVENTS_PAGE,
      name: constants.EVENTS_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "events" */ '../views/Events/Events.vue'),
    },
    {
      path: routes.IDENTITY_PAGE,
      name: constants.IDENTITY_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "identity" */ '../views/Identity.vue'),
    },
    {
      path: routes.REFERRAL_PAGE,
      name: constants.REFERRAL_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "referral" */ '../views/Referral.vue'),
    },
    {
      path: routes.MESSAGE_PAGE,
      name: constants.MESSAGE_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "message" */ '../views/Message/Message.vue'),
    },
    //{
    //  path: routes.MESSAGE_BK_PAGE,
    //  name: constants.MESSAGE_BK_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "message" */ '../views/Message/Message_bk.vue'),
    //},
    {
      path: routes.SETTING_PAGE,
      name: constants.SETTING_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "setting" */ '../views/Setting.vue'),
    },
    {
      path: routes.LOGIN_PAGE,
      name: constants.LOGIN_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    },
    {
      path: routes.LOGIN_KECUHUI_PAGE,
      name: constants.LOGIN_KECUHUI_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "login-kecuhui" */ '../views/LoginKeCuHui.vue'),
    },
    {
      path: routes.LOGIN_PHONE_PAGE,
      name: constants.LOGIN_PHONE_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "login-phone" */ '../views/LoginPhone.vue'),
    },
    {
      path: routes.LOGOUT_PAGE,
      name: constants.LOGOUT_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "logout" */ '../views/Logout.vue'),
    },
    {
      path: routes.PASSWORD_FORGET_PAGE,
      name: constants.PASSWORD_FORGET_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "password-forget" */ '../views/Password/Forget.vue'),
    },
    {
      path: routes.PASSWORD_CONFIRM_PAGE,
      name: constants.PASSWORD_CONFIRM_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "password-confirm" */ '../views/Password/Confirm.vue'),
    },
    {
      path: routes.PASSWORD_RESET_PAGE,
      name: constants.PASSWORD_RESET_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "password-reset" */ '../views/Password/Reset.vue'),
    },
    {
      path: routes.PASSWORD_SUCCESS_PAGE,
      name: constants.PASSWORD_SUCCESS_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "password-success" */ '../views/Password/Success.vue'),
    },
    // {
    //   path: routes.MUST_READ_PAGE,
    //   name: constants.MUST_READ_PAGE_CHUNK_NAME,
    //   component: () => import(/* webpackChunkName: "must-read" */ '../views/MustRead.vue'),
    // },
    {
      path: `${routes.MAIN_MODE_BOOK_PAGE}/reading/:readingId`,
      name: `${constants.MAIN_MODE_BOOK_PAGE_CHUNK_NAME}-reading`,
      component: () => import(/* webpackChunkName: "book" */ '../views/MainMode/MainModeBook.vue'),
    },
    {
      path: `${routes.MALL_ESG_REGISTRATION_PAGE}`,
      name: constants.MALL_ESG_REGISTRATION_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "esg-registration" */ '../views/Mall/ESG/EsgRegistration.vue'),
    },
    {
      path: `${routes.ESG_ORDER_COMPLETED_PAGE}`,
      name: constants.ESG_ORDER_COMPLETED_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "esg-order-complete" */ '../views/Mall/ESG/EsgOrderCompleted.vue'
        ),
    },
    {
      path: `${routes.MALL_PAYPAL_PAGE}`,
      name: constants.MALL_PAYPAL_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "mall-paypal" */ '../views/Mall/Paypal.vue'),
    },
    {
      path: `${routes.MALL_ORDER_PAGE}/:goodId`,
      name: constants.MALL_ORDER_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "mall-order" */ '../views/Mall/Order.vue'),
    },
    {
      path: `${routes.MALL_ORDER_PAGE}/:goodId/:vendor_oid`,
      redirect: (to) => {
        return {
          path: `${routes.MALL_ORDER_PAGE}/${to.params.goodId}`,
          query: {
            vendor_oid: to.params.vendor_oid,
            source: to.query.source,
            limitYear: to.query.limitYear,
          },
        };
      },
    },
    {
      path: `${routes.MALL_TRADE_PAGE}`,
      name: constants.MALL_TRADE_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "mall-order" */ '../views/Mall/Order.vue'),
    },
    {
      path: `${routes.MALL_WRITE_OFF_PAGE}`,
      name: constants.MALL_WRITE_OFF_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "write-off" */ '../views/Mall/WriteOff.vue'),
    },
    //{
    //  path: `${routes.MALL_ITEM_PAGE}`,
    //  name: constants.MALL_ITEM_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "mall-item" */ '../views/Mall/MallItem.vue'),
    //},
    //{
    //  path: routes.MALL_CATEGORY_COUPON_PAGE,
    //  name: constants.MALL_CATEGORY_COUPON_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "mall-category-coupon" */ '../views/Mall/CategoryCoupon.vue'),
    //},
    //{
    //  path: `${routes.MALL_GOOD_COUPON_PAGE}:goodId`,
    //  name: constants.MALL_GOOD_COUPON_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "mall-good-coupon" */ '../views/Mall/GoodCoupon.vue'),
    //},
    //{
    //  path: `${routes.MALL_CATEGORY_PAGE}`,
    //  name: constants.MALL_CATEGORY_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "mall-category" */ '../views/Mall/Category.vue'),
    //},
    //{
    //  path: `${routes.MALL_GOOD_PAGE}:goodId`,
    //  name: constants.MALL_GOOD_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "mall-good" */ '../views/Mall/Good.vue'),
    //},
    {
      path: `${routes.ACHIEVEMENTS_PAGE}`,
      name: constants.ACHIEVEMENTS_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "achievements" */ '../views/Achievements.vue'),
    },
    //{
    //  path: `${routes.READER_PAGE}`,
    //  name: constants.READER_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "reader" */ '../views/Reader.vue'),
    //},
    {
      path: `${routes.POINTS_PAGE}`,
      name: constants.POINTS_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "points" */ '../views/Points/Points.vue'),
    },
    //{
    //  path: `${routes.PRIVACY_PAGE}`,
    //  name: constants.PRIVACY_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "Privacy" */ '../views/Privacy/Privacy.vue'),
    //},
    {
      path: `${routes.ACCOUNT_CANCELLATION_PAGE}`,
      name: constants.ACCOUNT_CANCELLATION_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "account-cancellation" */ '../views/AccountCancellation/AccountCancellation.vue'
        ),
    },
    {
      path: `${routes.RANKING_PAGE}`,
      //name: constants.RANKING_PAGE_CHUNK_NAME,
      //component: () => import(/* webpackChunkName: "ranking" */ '../views/Ranking/Ranking.vue'),
      redirect: (to) => {
        return {
          path: `${routes.MAIN_MODE_COURSE_PAGE}/${to.params.courseId}/${routes.MAIN_MODE_COURSE_RANKING_PAGE}`,
        };
      },
    },
    {
      path: `${routes.ACTIVITY_TRANSCRIPT_PAGE}`,
      name: constants.ACTIVITY_TRANSCRIPT_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "activity-transcript" */ '../views/Activity/Transcript.vue'),
    },
    {
      path: routes.EVENT_REDIRECT_PAGE,
      name: constants.EVENT_REDIRECT_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "event-redirect" */ '../views/EventRedirect.vue'),
    },
    {
      path: routes.ALL_COURSES_PAGE,
      name: constants.ALL_COURSES_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "all-courses" */ '../views/AllCourses.vue'),
    },

    {
      path: routes.COUPON_PAGE,
      name: constants.COUPON_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "coupon" */ '../views/Coupon.vue'),
    },
    {
      path: `${routes.FLASH_CARD_LANDING_PAGE}/:courseId`,
      name: constants.FLASH_CARD_LANDING_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "flash-card-landing" */ '../views/FlashCard/FlashCardLanding/FlashCardLanding.vue'
        ),
    },
    {
      path: `${routes.FLASH_CARD_DETAIL_PAGE}/:courseId/book/:bookId`,
      name: constants.FLASH_CARD_DETAIL_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "flash-card-detail" */ '../views/FlashCard/FlashCardDetail/FlashCardDetail.vue'
        ),
    },
    {
      path: `${routes.FLASH_CARD_FAVORITE_PAGE}/:courseId`,
      name: constants.FLASH_CARD_FAVORITE_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "flash-card-detail" */ '../views/FlashCard/FlashCardDetail/FlashCardDetail.vue'
        ),
    },
    //{
    //  path: routes.TEACHERS_PAGE,
    //  name: constants.TEACHERS_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "teachers" */ '../views/Teachers.vue'),
    //},
    {
      path: routes.APP_PAGE,
      name: constants.APP_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "app-page" */ '../views/App.vue'),
    },
    {
      path: `${routes.TRAINING_CAMP_PAGE}`,
      name: constants.TRAINING_CAMP_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "training-camp" */ '../views/TrainingCamp/TrainingCamp/TrainingCamp.vue'
        ),
    },
    {
      path: `${routes.TRAINING_CAMP_PERSONAL_PAGE}`,
      name: constants.TRAINING_CAMP_PERSONAL_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "training-camp" */ '../views/TrainingCamp/TrainingCamp/TrainingCamp.vue'
        ),
    },
    {
      path: `${routes.TRAINING_CAMPS_PAGE}`,
      name: constants.TRAINING_CAMPS_PAGE_CHUNK_NAME,
      component: () =>
        import(
          /* webpackChunkName: "training-camps" */ '../views/TrainingCamp/TrainingCamps/TrainingCamps.vue'
        ),
    },
    //{
    //  path: routes.ABOUT_PAGE,
    //  name: constants.ABOUT_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    //},
    //{
    //  path: routes.LEGAL_PAGE,
    //  name: constants.LEGAL_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "legal" */ '../views/Legal.vue'),
    //},

    {
      path: `${routes.ORDER_DETAIL_PAGE}/:type/:id`,
      name: constants.ORDER_DETAIL_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "order-detail" */ '../views/Mall/OrderDetail.vue'),
    },
    {
      path: `${routes.MY_ORDER_PAGE}`,
      name: constants.MY_ORDER_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "my-order" */ '../views/Mall/MyOrder.vue'),
    },

    {
      path: `${routes.IM_TEAM_ANNOUNCEMENT_PAGE}/:teamId`,
      name: constants.IM_TEAM_ANNOUNCEMENT_PAGE_CHUNK_NAME,
      component: () =>
        import(/* webpackChunkName: "im-team-announcement" */ '../views/IMTeamAnnouncement.vue'),
    },
    {
      path: `${routes.ALUMNI_PAGE}`,
      name: constants.ALUMNI_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "alumni" */ '../views/Alumni.vue'),
    },
    //{
    //  path: `${routes.AGREEMENT_PAGE}`,
    //  name: constants.AGREEMENT_PAGE_CHUNK_NAME,
    //  component: () => import(/* webpackChunkName: "alumni" */ '../views/Agreement.vue'),
    //},
    {
      path: `${routes.AI_PAGE}`,
      name: constants.AI_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "ai" */ '../views/AI.vue'),
    },
    // {
    //   path: `${routes.INVOICE_PAGE}`,
    //   name: constants.INVOICE_PAGE_CHUNK_NAME,
    //   component: () => import(/* webpackChunkName: "ai" */ '../views/Invoice.vue'),
    // },
    {
      path: '*',
      redirect: () => routes.DASHBOARD_PAGE,
    },
    {
      path: `${routes.CAREER_PAGE}/:planId`,
      name: constants.CAREER_PAGE_CHUNK_NAME,
      component: () => import(/* webpackChunkName: "career" */ '../views/Career/Career.vue'),
    },
  ],
});
